import { render, staticRenderFns } from "./AdminCourse.vue?vue&type=template&id=bb71419c&scoped=true&"
import script from "./AdminCourse.vue?vue&type=script&lang=js&"
export * from "./AdminCourse.vue?vue&type=script&lang=js&"
import style0 from "./AdminCourse.vue?vue&type=style&index=0&id=bb71419c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb71419c",
  null
  
)

export default component.exports